import { api } from "..";

export async function clearSuspendedMatches(userId?: number) {
  const res = await api.client.delete("/matches/suspended", {
    params: { userId },
  });
  return res.data;
}
